import React from 'react';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { MapPinWithCardV2 } from '@shared/components/JoyInteractableMap/MapPin';
import { pxToRem } from '@withjoy/joykit/theme';
import { MapMarker } from '@withjoy/joykit/icons';
import { LazyJoyInteractableMap } from '@shared/components/JoyInteractableMap';
import type { LatLngLiteral } from '@shared/core/google-maps/types';
import { useTranslation } from '@shared/core';

type AutoPopulatedStayAreasMapProps = Readonly<{
  venueLocation: LatLngLiteral;
}>;

/**
 * Renders venue name with map marker icon
 */
const VenueNameDisplay: React.FC<Readonly<{ name: string }>> = ({ name }) => (
  <Flex
    alignItems="center"
    gap={2}
  >
    <MapMarker
      size={16}
      color="mono14"
    />
    <TextV2
      typographyVariant="body1"
      fontSize={pxToRem(14)}
      fontWeight={600}
      color="mono15"
    >
      {name}
    </TextV2>
  </Flex>
);

/**
 * Map content component that renders the venue marker
 */
export const AutoPopulatedStayAreasMap: React.FC<AutoPopulatedStayAreasMapProps> = ({ venueLocation }) => {
  const { tq } = useTranslation('stayAreasAdmin');

  return (
    <Box
      position="relative"
      width="100%"
      height="100%"
      flex={1}
    >
      <LazyJoyInteractableMap
        center={venueLocation}
        autoCenterAndZoom
        radiusMiles={3}
        gestureHandling="none"
      >
        {/* Venue Marker */}
        <MapPinWithCardV2
          label={<VenueNameDisplay name={tq`Your Venue`} />}
          position={venueLocation}
          isActive={false}
          isCardVisible={false}
          intent={'noBorder'}
          showOnTop
        />
      </LazyJoyInteractableMap>
    </Box>
  );
};
